import React from "react";
import {OrbitComponent} from "../../../../../../base-components/orbit-component/orbit-component";
import {
    IGameContextViewModel
} from "../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {observer} from "mobx-react";
import {
    GamePlayPcHeaderBarVendorSessionIdBox
} from "../../boxes/vendor-session-id/game-play-pc-header-bar-vendor-session-id.box";
import {CyClass} from "../../../../../../../../common/cy-classes";

interface GamePlayPcHeaderBarVendorSessionIdComponentProps {
    gameContext: IGameContextViewModel;
    hide?: boolean;
}

export const GamePlayPcHeaderBarVendorSessionIdComponent = observer(
    class GamePlayPcHeaderBarVendorSessionIdComponent extends OrbitComponent<GamePlayPcHeaderBarVendorSessionIdComponentProps> {
        render() {
            if(!this.props.gameContext.gameSessionData.vendorGameSessionId || this.props.hide) {
                return null;
            }

            return (
                <GamePlayPcHeaderBarVendorSessionIdBox className={CyClass('cy-game-navbar-session-id')}>
                    {this.services.translation.translate('GAME_WINDOW_VENDOR_SESSION_ID', {sessionID: this.props.gameContext.gameSessionData.vendorGameSessionId})}
                </GamePlayPcHeaderBarVendorSessionIdBox>
            );
        }
    }
);